import * as React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useEffect } from 'react';

export const CustomizedSnackbar = ({ action, message }) => {
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        console.log(action);
        if(action){
            setOpen(true);
            console.log(action," : snackbar opened");
        }

    }, [action]);

    const openSnackbar = () => {
        setOpen(true);
    };

    const closeSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    }

    return (
        <>
            <Snackbar open={open} autoHideDuration={5000} onClose={closeSnackbar} anchorOrigin={{vertical:'top',horizontal:'center'}}>
                <Alert onClose={closeSnackbar} severity='error' sx={{ width: '100%', fontSize:'1rem' }}>
                    {message}
                </Alert>
            </Snackbar>

        </>
    )

}